import { Html5Qrcode } from 'html5-qrcode'
import { QrCodeScannerContract } from './QrCodeScannerContract'
import { BarcodeScanner } from '@capacitor-mlkit/barcode-scanning'
import { nextTick } from 'vue'

export const html5QrScannerImplementation: QrCodeScannerContract & {
  html5QrCode?: Html5Qrcode
} = {
  requestPermission: () => {
    return new Promise((resolve, reject) => {
      return BarcodeScanner.requestPermissions()
        .then((result) => resolve(result.camera === 'granted' || result.camera === 'limited'))
        .catch(() => reject(false))
    })
  },

  scan () {
    return new Promise((resolve, reject) => {
      nextTick(() => {
        this.html5QrCode = new Html5Qrcode('web-scanner-target')

        try {
          this.html5QrCode?.start(
            { facingMode: 'environment' },
            { fps: 10 },
            parsedCode => {
              resolve(parsedCode)
            },
            () => {},
          )
        } catch (error: any) {
          reject(error)
        }
      })
    })
  },

  stop () {
    return new Promise(() => {
      this.html5QrCode?.stop()
    })
  },
}
